import { Col, Layout, Row, Skeleton, Space, Typography } from "antd";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import { FOOTER_CONTACT } from "@/constants/home";
import { ROUTES } from "@/constants/routes";
import { policyService } from "@/services";
import { PolicyNavItem } from "@/types";

const { Footer: AntFooter } = Layout;
const { Text, Title } = Typography;

export const Footer = () => {
  const [policyNavigation, setPolicyNavigation] = useState<PolicyNavItem[]>([]);
  const [isPolicyLoading, setIsPolicyLoading] = useState(true);

  useEffect(() => {
    let active = true;

    const bootstrap = async () => {
      try {
        const response = await policyService.getNavigation();

        if (active) {
          setPolicyNavigation(response);
        }
      } catch {
        if (active) {
          setPolicyNavigation([]);
        }
      } finally {
        if (active) {
          setIsPolicyLoading(false);
        }
      }
    };

    void bootstrap();

    return () => {
      active = false;
    };
  }, []);

  return (
    <AntFooter className="site-footer">
      <div className="footer-shell">
        <Row gutter={[24, 28]}>
          <Col xs={24} md={12} lg={7}>
            <Title className="site-footer__brand" level={4}>
              {FOOTER_CONTACT.brandName}
            </Title>
            <Text>{FOOTER_CONTACT.description}</Text>
          </Col>
          <Col xs={24} md={12} lg={5}>
            <Title level={5}>Điều hướng</Title>
            <Space className="site-footer__links" direction="vertical" size={8}>
              <Link to={ROUTES.PRODUCTS}>Sản phẩm</Link>
              <Link to={ROUTES.GOLD_PRICE}>Giá vàng</Link>
              <Link to={ROUTES.NEWS}>Tin tức</Link>
              <Link to={ROUTES.CHECKOUT}>Thanh toán</Link>
            </Space>
          </Col>
          <Col xs={24} md={12} lg={6}>
            <Title level={5}>Chính sách</Title>
            <Space className="site-footer__links" direction="vertical" size={8}>
              {isPolicyLoading
                ? Array.from({ length: 4 }).map((_, index) => (
                    <Skeleton.Button
                      active
                      block
                      key={`policy-link-${index.toString()}`}
                      size="small"
                    />
                  ))
                : policyNavigation.map((item) => (
                    <Link key={item.slug} to={item.href}>
                      {item.title}
                    </Link>
                  ))}
            </Space>
          </Col>
          <Col xs={24} md={12} lg={6}>
            <Title level={5}>Liên hệ</Title>
            <Space direction="vertical" size={8}>
              <Text>{FOOTER_CONTACT.email}</Text>
              <Text>{FOOTER_CONTACT.phone}</Text>
              <Text>{FOOTER_CONTACT.address}</Text>
              <Text>{FOOTER_CONTACT.hours}</Text>
            </Space>
          </Col>
        </Row>
      </div>
    </AntFooter>
  );
};
